define([
  'lib/sumome/service/index',
  'articles',
  'moment',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/smartbar/popup',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/clicktriggers',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/displayrules',
], (SumoService, Articles, moment, SmartBarPopup, MainService, ClickTriggers, DisplayRules) => {

  class SmartBarService extends SumoService.Service {
    static SHOWN_COOKIE = '__smSmartbarShown';
    static OPT_OUT_COOKIE = '__smSmartBarOptOut';

    constructor(api, service, smartbar) {
      super(api);
      this.fetchFeatures().then(() => {
        this.lastScroll = -1;

        this.smartbar = new SmartBarPopup(this, smartbar);
        this.smartbarHeight = 0;

        this.onResize = this.onResize.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onClose = this.onClose.bind(this);

        this.addEvent(window, 'resize', this.onResize);

        // Cookie function initializations
        this.setOptOutCookie = service.setOptOutCookie.bind(this, SmartBarService.OPT_OUT_COOKIE);
        this.setShownCookie = service.setShownCookie.bind(this, SmartBarService.SHOWN_COOKIE);
        this.setCtaCookie = service.setCtaCookie.bind(this);
        this.setSubscribedCookie = service.setSubscribedCookie.bind(this);
        this.setPushSubscribedCookie = service.setPushSubscribedCookie.bind(this);

        this.onShow();

        // If share loads _after_ smart bar, we need to rerun style buffer
        if (!document.querySelector('.sumome-share-client-wrapper')) {
          this.api.on('9e8a4d2a-6f8c-415e-851b-bdfe4c01d5c1/service/rendered', () => {
            this.smartbar.styleBuffer();
          });
        }
      });
    }

    onShow() {
      this.smartbar.show();

      if (this.smartbar.settings.get('show_type') === 'smart' || (this.smartbar.settings.get('show_type') === 'static' && this.smartbar.settings.get('position') === 'top')) {
        this.addEvent(window, 'scroll', this.onScroll);
      } else if (this.smartbar.settings.get('show_type') === 'fixed' && this.smartbar.settings.get('position') === 'top') {
        this.addEvent(window, 'scroll', this.smartbar.styleBuffer);
      }
    }

    onClose() {
      this.removeEvent(window, 'resize', this.onResize);
      this.removeEvent(window, 'scroll', this.onScroll);
      this.removeEvent(window, 'scroll', this.smartbar.styleBuffer);
    }

    onScroll() {
      // If scroll event is bound, then smart bar must be set to Smart mode
      const position = this.smartbar.settings.get('position');
      const showType = this.smartbar.settings.get('show_type');

      const smartbarEl = document.querySelector('.smartbar-popup');
      const containerEl = smartbarEl ? smartbarEl.querySelector('.sumome-react-wysiwyg-popup-container') : null;

      const currentScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const smartbarHeight = containerEl ? containerEl.offsetHeight : 0;

      // If static top, handle fixed elements differently
      if (showType === 'static') {
        this.smartbar.staticScroll();
        return;
      }

      if (Math.abs(this.lastScroll - currentScrollTop) <= 5) return false;

      if (currentScrollTop > this.lastScroll && currentScrollTop > smartbarHeight && containerEl.style[position] !== `-${smartbarHeight}px`) {
        containerEl.style[position] = `-${smartbarHeight}px`;
        this.smartbar.smartHide();
      } else if (currentScrollTop < this.lastScroll && containerEl.style[position] !== '0px') {
        containerEl.style[position] = '0px';
        this.smartbar.smartShow();
      }

      this.lastScroll = currentScrollTop;
    }

    onResize() {
      const smartbarEl = document.querySelector('.smartbar-popup');
      const containerEl = smartbarEl ? smartbarEl.querySelector('.sumome-react-wysiwyg-popup-container') : null;
      const position = this.smartbar.settings.get('position');
      const showType = this.smartbar.settings.get('show_type');

      if (!this.smartbarHeight || this.smartbarHeight !== containerEl.offsetHeight || (showType === 'static' && position === 'bottom')) {
        this.smartbar.onResize();
        this.smartbarHeight = containerEl ? containerEl.offsetHeight : 0;
      }
    }
  }

  return SmartBarService;
});
